// src/services/auth.js
import axios from "axios";
import { getToken, logout } from "../utils/auth";
// ==============================
// Base del backend de autenticación
// ==============================
//
// Usamos la variable de entorno REACT_APP_AUTH_API_BASE si existe,
// si no, por defecto apuntamos al backend local en 8000.

// IMPORTANTE: que NO termine en /  (si termina, se lo quitamos abajo).
//
const RAW_API_BASE =
  (process.env.REACT_APP_AUTH_API_BASE || "http://127.0.0.1:8000") + "/users";

const API_URL = RAW_API_BASE.replace(/\/$/, "");

// ==============================
// Paso 1: /auth/login
// ==============================
/**
 * Llama al backend /auth/login
 * - Valida usuario/contraseña
 * - Genera código 2FA
 * - Devuelve { detail, modo_debug, codigo? }
 */

console.log("[DMARC FRONT] API_BASE =", API_URL);

export const user_api = axios.create({
  baseURL: API_URL,
  // opcional: timeout
  timeout: 60000,
});

const API_ROOT = (process.env.REACT_APP_AUTH_API_BASE || "http://127.0.0.1:8000").replace(/\/$/, "");

export const dmarc_api = axios.create({
  baseURL: API_ROOT,
  timeout: 60000,
});

export async function login(correo, password) {
  const url = `${API_URL}/login`;
  const resp = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ correo, password }),
  });

  let data = {};
  try {
    data = await resp.json();
  } catch {
    data = {};
  }

  if (!resp.ok) {
    console.error("[LOGIN] Error HTTP", resp.status, data, "URL:", url);
    const msg = (data && data.detail) || "Error al iniciar sesión";
    throw new Error(msg);
  }

  // data: { detail, modo_debug, codigo? }
  return data;
}

// ==============================
// Paso 2: /auth/verify-code
// ==============================
/**
 * Llama al backend /auth/verify-code
 * - Valida código 2FA
 * - Devuelve { access_token, token_type, nombre, rol, correo, numcliente? }
 */
export async function verifyCode(correo, codigo) {
  const url = `${API_URL}/verify-code`;

  const resp = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ correo, codigo }),
  });

  let data = {};
  try {
    data = await resp.json();
  } catch {
    data = {};
  }

  if (!resp.ok) {
    console.error("[VERIFY-CODE] Error HTTP", resp.status, data, "URL:", url);
    const msg = (data && data.detail) || "Error al validar código";
    throw new Error(msg);
  }

  // data: { access_token, token_type, nombre, rol, correo, numcliente? }
  return data;
}

/* Por hacer: mover al archivo correcto!
 * vvv Funciones que no deberían estár aquí vvv
 */

export async function recover_password(correo) {
  const url = `${API_URL}/recover-password`;

  console.log(JSON.stringify({ correo }));

  const resp = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ correo }),
  });

  let data = {};
  try {
    data = await resp.json();
  } catch {
    data = {};
  }

  if (!resp.ok) {
    console.error(
      "[RECOVER PASSWORD] Error HTTP",
      data.status,
      data.toString(),
      "URL:",
      url,
    );
    const msg = (data && data.detail) || "Error al recuperar contraseña";
    throw new Error(msg);
  }

  // data: { detail }
  return data;
}

export async function change_password(password, password2, email, code) {
  const url = `${API_URL}/recover-password/change-password`;
  const resp = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ password, password2, code, email }),
  });

  let data = {};
  try {
    data = await resp.json();
  } catch {
    data = {};
  }

  if (!resp.ok) {
    console.error(
      "[CHANGE PASSWORD] Error HTTP",
      data.status,
      JSON.stringify(data),
      "URL:",
      url,
    );
    const msg = (data && data.detail) || "Error al cambiar contraseña";
    throw new Error(msg);
  }

  // data: { detail }
  return data;
}

export async function expiresSoon(correo) {
  const url = `${API_URL}/expires-soon`;
  const resp = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ correo }),
  });

  let data = {};
  try {
    data = await resp.json();
  } catch {
    data = {};
  }

  if (!resp.ok) {
    console.error(
      "[EXPIRES SOON] Error HTTP",
      data.status,
      JSON.stringify(data),
      "URL:",
      url,
    );
    const msg =
      (data && data.detail) ||
      "Error al validar la fecha de expiración de la cuenta.";
    throw new Error(msg);
  }

  return data;
}


user_api.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

user_api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      logout();
    }
    return Promise.reject(error);
  },
)
dmarc_api.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

dmarc_api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      window.dispatchEvent(new Event('session-expired'));
    }
    return Promise.reject(error);
  }
);

dmarc_api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 403) {
      window.dispatchEvent(new Event('unauthorized-domain'));
    }
    return Promise.reject(error);
  }
);